<template>
  <div class="configurations">
    <div class="uk-container">
      <button
        v-on:click="addConfig"
        class="uk-button  uk-align-right uk-button-primary uk-button-small"
      >
        Add a set
      </button>
    </div>
    <br />
    <SingleConfig
      v-for="config in configs"
      v-bind:id="config.id"
      v-bind:key="config.id"
    ></SingleConfig>
  </div>
</template>
<script>
import SingleConfig from "@/components/churn/SingleConfig.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  name: "HelloWorld",
  components: {
    SingleConfig
  },
  props: {
    msg: String
  },
  methods: {
    ...mapActions({
      addConfig: "churn/addConfig"
    })
  },
  computed: {
    ...mapState({
      configs: state => state.churn.configs
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
